module.exports = __webpack_public_path__ + "img/mailbox.1ec978d3.svg";